<template>
  <SectionTemplate
    title="不止于观看，实现深度互动与理解"
    desc="独有的PPT智能知识库与双模式体验，让内容从“被动灌输”变为“主动探索”。极大提升信息传递的广度、深度与效率。"
  >
    <div class="card-list">
      <FeatureCard
        v-for="(feature, index) in featureList"
        :key="index"
        v-bind="feature"
        btnText="免费试用"
        :action="handler"
      />
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import FeatureCard from '@/design/components/feature-card/index.vue';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';
import { getFeUrl } from '~/utils/url';

const props = defineProps<{
  handler: () => void;
}>();

const featureList = computed(() => [
  {
    title: `PPT秒变智能知识库 \n打造专属问答大脑`,
    description:
      '上传PPT，AI自动提取关键信息构建专属知识库。数字人不仅能讲解，更能像真人专家一样，实时引用具体PPT页面内容，精准回答每一个问题。',
    image: getFeUrl('/youyan-platform/chat-ppt/features/1.jpg?x-oss-process=image/format,webp'),
    videoDesc: '',
  },
  {
    title: `浏览+问答随心切换 \n满足所有学习习惯`,
    description:
      '“浏览模式”让观众系统学习全部内容；“问答模式”支持随时语音/文字提问，秒获答案。两种模式无缝切换，让观众从“被动收听”变为“主动探索”，信息吸收率倍增。',
    image: getFeUrl('/youyan-platform/chat-ppt/features/2.jpg?x-oss-process=image/format,webp'),
    reverse: true,
    videoDesc: '',
  },
  {
    title: `学习行为可追踪 \n讲解互动精准到人`,
    description:
      '后台同步记录用户行为。教师实时掌握学生进度，数字人智能体智能匹配教学节奏，课堂互动精准到人。企业的客户关注点一目了然，服务针对性优化，提升销售转化率。',
    videoDesc: '',
    image: getFeUrl('/youyan-platform/chat-ppt/features/3.jpg?x-oss-process=image/format,webp'),
  },
  {
    title: `支持超万人同时在线 \n稳定流畅无卡顿`,
    description:
      '基于强大的云平台，支持数万人同时在线互动，体验依然流畅稳定。无论是万人学校或企业内训、公开课，还是大型产品发布会，有言智能体都能轻松应对。',
    reverse: true,
    videoDesc: '',
    image: getFeUrl('/youyan-platform/chat-ppt/features/4.jpg?x-oss-process=image/format,webp'),
  },
  {
    title: `跨平台一键分享 \n扫码即用`,
    description:
      '创作并导出完成后，即可生成专属链接和二维码。观众无需下载任何APP，扫码即看、即问。让您的智慧成果，以最便捷的方式触达每一位学生、客户或员工。',
    videoDesc: '',
    image: getFeUrl('/youyan-platform/chat-ppt/features/5.jpg?x-oss-process=image/format,webp'),
  },
]);
</script>
<style lang="scss" scoped>
@media (min-width: $media-pc) {
  .card-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 240px;
    width: 100%;
  }
}
@media (max-width: $media-mobile) {
  .card-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 72px;
    width: 100%;
  }
}
</style>
